const {google, Vue, ga, jQuery: $} = window;
import { dealerExtendAddress } from '../../utils/dealerExtendAddress';
import {
	generateBuilderUI,
    leadFormData,
} from "../_utilities";
import {
	getHash
} from "../_social-share.js";
import { ACTIONS } from "../_actions";
import { store, store$ } from "../_config-store";
import { localize, localCountries } from "../_localize.js";
import { formValidation } from '../../leadSubmitValidation';

const viewOptions$ = store$
	.map(state => state.viewOptions);
const quoteDisabled$ = store$
	.map(state => state.quoteDisabled);
const truckModel$ = store$
	.map(state => state.truckModel);

export const options = {
	template:
		`<form id="request-quote" @submit.prevent="" v-bind:class="{loading: loading}" v-bind:style="{ 'display': hideFormStyle }">
	<template v-if="!thankYou">
		<h1 v-html="formData.Heading"></h1>
		<p v-html="formData.Intro"></p>
	</template>
	<template v-else>
		<h1>{{local('Thank You')}}, {{fields[0].value}}!</h1>
		<p v-html="local('Your quote has been submitted. Please reach out to your selected dealer below with any questions.')"></p>
		<div class="location" v-if="dealer">
			<div class="content">
				<h2 v-bind:class="{elite: dealer.EliteSupport}">{{dealer.name}}</h2>
				<a class="phone" v-bind:href="'tel:' + dealer.phone"><span class="icon-phone"></span>{{dealer.phone}}</a>
				<a class="address" v-bind:href="dealer.mapLink" target="_blank"><span class="icon-map-pin"></span><span v-html="dealer.htmlAddress"></span></a>
				<a class="website" v-bind:href="'http://' + dealer.website" target="_blank">{{dealer.website}}</a>
			</div>
			<div class="actions">
				<a class="details" role="button" v-bind:href="'/Dealer?code='+dealer.code+'&name='+encodeURIComponent(dealer.name)">View Details</a>
				<a class="directions" role="button" v-bind:href="dealer.mapLink" target="_blank">Get Directions</a>
			</div>
		</div>
	</template>
	<template v-if="!thankYou" v-for="field in fields">
		<div v-if="field.type === 'num8'">
			<input
				v-bind:id="field.key"
				v-bind:name="field.key"
				type="text"
				v-bind:placeholder="field.label + (field.required ? ' *' : '')"
				v-model="field.value"
				v-bind:validate="field.key === 'MCUSDot' ? null : 'onsubmit'"
				requiredtype="num8Pattern"
			>
		</div>
		<div v-if="field.type === 'text' && field.required">
			<input
				v-bind:id="field.key"
				v-bind:name="field.key"
				type="text"
				v-bind:placeholder="field.label + (field.required ? ' *' : '')"
				v-model="field.value"
				validate="onsubmit"
				requiredtype="name"
			>
		</div>
		<div v-if="field.type === 'text' && !field.required">
			<input
				v-bind:id="field.key"
				v-bind:name="field.key"
				type="text"
				v-bind:placeholder="field.label + (field.required ? ' *' : '')"
				v-model="field.value"
			>
		</div>
		<div v-if="field.type === 'state'">
		  <input
			:id="field.key"
			:name="field.key"
			type="text"
			:placeholder="field.label + (isStateRequired ? ' *' : '')"
			v-model="field.value"
			:validate="isStateRequired ? 'onsubmit' : null"
			:requiredtype="isStateRequired ? 'state' : null"
		  >
		</div>
		</div>
		<div v-else-if="field.type === 'email'">
			<input
				v-bind:id="field.key"
				v-bind:name="field.key"
				type="email"
				v-bind:placeholder="field.label + (field.required ? ' *' : '')"
				v-model="field.value"
				validate="onsubmit"
				requiredtype="email"
			>
		</div>
		<div v-else-if="field.type === 'number'">
			<input
				v-bind:id="field.key"
				v-bind:name="field.key"
				type="number"
				v-bind:placeholder="field.label + (field.required ? ' *' : '')"
				v-model="field.value"
			>
		</div>
		<div v-else-if="field.type === 'hidden'">
			<input
				v-bind:id="field.key"
				v-bind:name="field.key"
				type="hidden"
				v-bind:placeholder="field.label + (field.required ? ' *' : '')"
				v-model="field.value"
			>
		</div>
		<div v-else-if="field.type === 'tel'" type="tel">
			<input
				v-bind:id="field.key"
				v-bind:name="field.key"
				type="tel"
				v-bind:placeholder="field.label + (field.required ? ' *' : '')"
				v-model="field.value"
				validate="onsubmit"
				requiredtype="tel"
			>
			<input type="tel" placeholder="Ext." v-model="phoneExtension" id="Ext">
		</div>
		<div v-else-if="field.type === 'textarea'">
			<textarea
				v-bind:id="field.key"
				v-bind:name="field.key"
				v-bind:placeholder="field.label + (field.required ? ' *' : '')"
				v-model="field.value"
				maxlength="500"
			></textarea>
		</div>
		<div v-else-if="field.type === 'select' && field.options.length > 0">
			<select
				v-bind:id="field.key"
				v-bind:name="field.key"
				v-bind:placeholder="field.label + (field.required ? ' *' : '')"
				v-model="field.value"
				validate="onsubmit"
				requiredtype="sel"
			>
				<option v-if="field.label" value="" disabled>{{field.label + (field.required ? ' *' : '')}}</option>
				<option v-for="option in field.options" v-bind:value="option">{{option}}</option>
			</select>
		</div>
		<div v-else-if="field.type === 'locationFromPostal'">
			<input
				v-bind:id="field.key + 'ZipCode'"
				v-bind:name="field.key + 'ZipCode'"
				type="text"
				v-bind:placeholder="local(field.label + ' Postal Code') + (field.required ? ' *' : '')"
				v-model="field.values['ZipCode']"
				validate="onsubmit"
				requiredtype="postalcode"
				@change="locationFromPostal(field.values)"
			>
			<select
				v-bind:id="field.key + 'Country'"
				v-bind:name="field.key + 'Country'"
				v-bind:placeholder="local(field.label + ' Country') + (field.required ? ' *' : '')"
				v-model="field.values['Country']"
				validate="onsubmit"
				requiredtype="country"
				@change="locationFromPostal(field.values)"
			>
				<option v-if="field.label" value="" disabled>{{local(field.label + ' Country') + (field.required ? ' *' : '')}}</option>
				<option v-for="option in countries" v-bind:value="option.code">{{option.name}}</option>
			</select>
		</div>
		<div v-else-if="field.type === 'check'">
			<input
				type="checkbox"
				class="filled-in"
				value="true"
				v-bind:id="field.key"
				v-bind:name="field.key"
				v-model="field.checked"
			>
			<label
				v-bind:for="field.key"
				v-html="field.label"
			></label>
		</div>
		<div v-else-if="field.type === 'dealer'" class="dealer" name="selDealer" id="selDealer">
			<header @click="expandDealer" v-bind:class="dealerExpanded ? 'expanded' : ''">{{!dealer ? field.label + (field.required ? ' *' : '') : local('My Dealer') + ': ' + dealer.name}}</header>
			<transition name="slide" :duration="300">
				<section v-show="dealerExpanded">
					<div region v-if="false">
						<label>{{local('Search in')}}</label>
						<select>
							<option>{{local('US & Canada')}}</option>
							<option>{{local('Global Dealer Locations')}}</option>
						</select>
					</div>
					<div specific v-if="dealerSearch">
						<input location :placeholder="local('City or Address')" id="Address">
						<span use-location @click.stop="useLocation"></span>
					</div>
					<div v-if="locationError">{{locationError}}</div>
					<div v-if="dealers.length > 0 && !dealersLoading">
						<h6>{{dealers.length}} {{dealerSearch ? 'nearest Results' : local('Dealers')}}</h6>
						<ul>
							<li v-for="dlr in dealers" @click="selectDealer(dlr,field)" v-bind:class="dealer === dlr ? 'selected' : ''">
								<label name>{{dlr.name}}</label>
								<label address v-if="dlr.city || dlr.state">{{getDealerAddress(dlr)}}</label>
								<label distance v-if="dealerSearch">{{getDistance(dlr.latitude,dlr.longitude) + ' ' + local('Miles Away')}}</label>
							</li>
						</ul>
					</div>
					<div v-if="dealersLoading" loading v-html="local('Checking for dealers near you...')"></div>
				</section>
			</transition>
			<input
				type="hidden"
				name="DealerCode"
				id="DealerCode"
				v-model="field.value"
				validate="onsubmit"
				requiredtype="dealer"
			>
		</div>
	</template>
	<div class="errors" v-if="errors.length > 0">
		<p v-for="error in errors">{{error}} {{local('Required')}}</p>
	</div>
	<footer v-if="!thankYou">
		<button type="button" @click="quoteSubmit" :disabled="quoteDisabled">{{formData.SubmitLabel}} {{loading ? '('+local('Loading')+'...)' : ''}}</button>
		<span class="note" v-show="quoteDisabled" v-html="local('Hang on while we update your truck...')"></span>
	</footer>
</form>`,
	data() {		
		return {
			countries: leadFormData().Countries || localCountries(),
			dealer: !window.dealers || window.dealers.length > 1 ? undefined : window.dealers[0],
			dealerExpanded: !window.dealers || window.dealers.length > 1 ? true : false,
			dealers: window.dealers || [],
			dealersLoading: false,
			dealerSearch: !window.dealers,
			errors: [],
			fields: leadFormData().Fields,
			formData: leadFormData(),
			loading: false,
			local(str) { return str; },
			location: undefined,
			locationError: '',
			phoneExtension: '',
			referrer: window.referrer ? window.referrer : '',
			thankYou: false
		}
	},
	subscriptions() {
		return {
			viewOptions: viewOptions$,
			quoteDisabled: quoteDisabled$,
			truckModel: truckModel$,
			store: store$
		}
	},
	computed: {
		hideFormStyle() {
			if (window.hideForm === 'True') {
				return this.local('none');
			} else {
				return this.local('block');
			}
		},
		isStateRequired() {
			const countryField = this.fields.find(field => field.type === 'locationFromPostal');
			if (countryField) {
				const country = countryField.values['Country'];
				return country === 'US' || country === 'CA';
			}
			return false;
		}
	},
	methods: {
		availableOptions: function(view) {
			return generateBuilderUI(this.store,view);
		},

		expandDealer() {
			this.dealerExpanded = !this.dealerExpanded;
		},

		getDistance(lat1, lon1) {
			let lat2 = this.location.latitude,
				lon2 = this.location.longitude,
				R = 6371, // Radius of the earth in km
				dLat = deg2rad(lat2 - lat1),  // deg2rad below
				dLon = deg2rad(lon2 - lon1),
				a =
					Math.sin(dLat / 2) * Math.sin(dLat / 2) +
					Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
					Math.sin(dLon / 2) * Math.sin(dLon / 2),
				c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)),
				d = R * c; // Distance in km
			return Math.round(d * 0.621371); // Return miles
		},

		getDealerAddress(dlr) {
			
			if (dlr.city && dlr.state)
				return `${dlr.city}, ${dlr.state}`;

			if (dlr.city)
				return dlr.city;

			if (dlr.state)
				return dlr.state;
        },

		joinedAttributes(paths, glue = '') {
			return _.compact(paths.reduce((list, path) => {
				return list.concat(_.at(this, path));
			}, [])).join(glue);
		},

		locationFromPostal(values) {
			let { ZipCode, Country } = values;
			return Country && ZipCode ?
				(new google.maps.Geocoder()).geocode({ componentRestrictions: { country: Country, postalCode: ZipCode } }, (results, status) => {
					if (status === 'OK') {
						let [{ address_components }] = results,
							city = (address_components.find(({ types }) => types.indexOf('locality') !== -1) || {}).short_name,
							state = (address_components.find(({ types }) => types.indexOf('administrative_area_level_1') !== -1) || {}).short_name;
						values.City = city;
						values.State = state;
					}
				}) : false;

		},

		quoteSubmit() {			
			const form = document.getElementById('request-quote');
			const validation = formValidation('Configurator', form, tippy);
			const isValid = validation.validate();
			
			if (isValid && !this.loading) {
				
				this.loading = true;

				if (typeof window.captchaKey === 'string' && window.captchaKey.length > 0) {
					if (!window.grecaptcha)
						this.loadCaptcha(captchaKey);
					else
						this.getCaptchaToken(window.captchaKey);
				} else {
					this.sendLead()
				}		
			}
		},

		getCaptchaToken(captchaKey) {
			window.grecaptcha.ready(() => {
				window.grecaptcha
					.execute(captchaKey, { action: 'submit' })
					.then(token => {
						this.setToken(token);
					});
			});
		},

		loadCaptcha(captchaKey) {
			const script = document.createElement('script');
			script.setAttribute('type', 'text/javascript');
			script.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${captchaKey}`);
			script.addEventListener('load', () => {
				this.getCaptchaToken(captchaKey)
			});
			document.body.appendChild(script);
		},

		setToken(token) {
			this.fields.push({ key: 'CaptchaToken', value: token });
			this.sendLead()
		},

		sendLead() {
			const dataFields = Object.assign(
				{
					Configuration: JSON.stringify(_.fromPairs(this.viewOptions.reduce((arr, optionGroup) => {
						return arr.concat(this.availableOptions(optionGroup.name).reduce((groupList, option) => {
							if (option.children && option.children.length) {
								option.children.forEach((child) => {
									if (child.current) {
										groupList.push([optionGroup.name + '|' + child.component, child.current]);
									}
								});
							}
							else if (_.at(option, 'options[0].current')[0]) {
								option.options.forEach((child) => {
									groupList.push([optionGroup.name + '|' + child.label, child.current]);
								});
							}
							else {
								groupList.push([optionGroup.name + '|' + option.label, option.current]);
							}
							return groupList;
						}, []));
					}, []))),
					FormType: this.formData.FormType,
					TruckHash: 'hash',
					OptionsMatrixType: this.formData.OptionsMatrixType,
					Referrer: this.formData.Referrer
				},
				this.fields.reduce((obj, field) => {
					if (field.type === 'locationFromPostal') {
						for (var x in field.values)
							obj[field.key + x] = field.values[x];
					}
					else if (field.type === 'dealer') {
						obj['DealerCode'] = this.dealer.code;
					}
					else if (field.type === 'cabtype') {
						obj[field.key] = this.store.truckCab;
					}
					else if (field.type === 'check') {
						obj[field.key] = field.checked;
					}
					else if (field.type === 'tel') {
						obj[field.key] = field.value;
						obj['phoneExtension'] = this.phoneExtension;
					}
					else if (field.type === 'isinternal') {
						obj[field.key] = window.self === window.top;
					}
					else if (field.key === 'Model') {
						if (this.truckModel === "M2 106 Plus") {
							obj['Model'] = 'M2 106 Plus';
						} else if (this.truckModel === "M2 106") {
							obj['Model'] = 'M2 106';
						} else {
							obj['Model'] = 'Cascadia';
						}
						/* HOLD ONTO THIS JUST IN CASE
						if (this.store.truckCab === '106" Day Cab') {
							console.log('CabType');
							obj['Model'] = 'M2 106';
						} else {
							obj['Model'] = 'Cascadia';
						}
						*/
					}
					else {
						obj[field.key] = field.value;
					}

					return obj;
				},
					{
						CabType: this.store.truckCab
					},
					{})
			);

			const token = this.fields.find(x => x.key === 'X-CSRF-TOKEN-FTL');

			getHash({ 'X-CSRF-TOKEN-FTL': token.value }).done((hash) => {

				dataFields['TruckHash'] = hash

				$.ajax({
					url: this.formData.Api,
					headers: { token },
					method: "POST",
					data: dataFields
				}).done(() => {
					if (this.formData.TaggingKey
						&& this.formData.TaggingKey !== ''
						&& gtag_report_conversion
						&& typeof gtag_report_conversion === 'function')
						gtag_report_conversion(this.formData.TaggingKey);

					let $configurator = $("#configurator");
					// Show thank you
					this.thankYou = true;
					this.loading = false;
					$configurator.animate({ scrollTop: $('#request-quote').offset().top + $configurator.scrollTop() });

					store.dispatch({
						type: ACTIONS.QUOTE_SUBMITTED,
						hash: hash
					});

				}).fail(() => {
					this.loading = false;
				});
			}).fail(() => {
				this.loading = false;
			});
		},

		selectDealer(dealer, field) {
			this.dealer = dealerExtendAddress(dealer);
			this.$emit('dealer-change');
			this.dealerExpanded = false;
			field.value = dealer.code;
			const tmpDealerCodeField = document.getElementById('DealerCode');
			tmpDealerCodeField.value = dealer.code;

			// Trigger validation for DealerCode to clear any error state
			const validation = formValidation('Configurator', document.getElementById('request-quote'), tippy);
			validation.processField(tmpDealerCodeField);
		},


		useLocation() {
			let input = $(this.$el).find('input[location]');
			fillGeo(input).done(latlng => {
				this.locationError = '';
				this.location = {
					latitude: latlng.lat,
					longitude: latlng.lng
				};
			}).fail(() => {
				console.error('error');
				this.locationError = this.local('We were unable to get your location.');
				this.location = undefined;
			});
		},
	},
	watch: {
		location() {			
			if (this.location) {
				this.dealersLoading = true;

				const dealerField = this.fields.find(x => x.type === 'dealer');

				const apiAddress = dealerField && dealerField.apiAddress && dealerField.apiAddress !== ''
					? dealerField.apiAddress
					: window.apiAddress;

				$.ajax({
					url: apiAddress,
					method: "GET",
					data: Object.assign({}, this.location, {
						count: 10,
						radius: 1000,
						type: 'FTL',
						countries: localCountries(true).map(({ code }) => code.toLowerCase()).join(',')
					})
				}).done(dealers => {
					this.dealers = filterDealers(window.truckModel || "P4", dealers);
				}).fail(() => {

				}).always(() => {
					this.dealersLoading = false;
				});
			}
			else {
				this.dealersLoading = false;
				this.dealers = [];
			}
		}
    },
	mounted() {
		// Attach third party functionality
		let $container = $(this.$el);
		setTimeout(() => {
			if ($container.find('input[location]')[0]) {
				let autocompleteLocation = new google.maps.places.Autocomplete($container.find('input[location]')[0], { types: ['geocode'] });
				// When the user selects an address from the dropdown, populate the address
				// fields in the form.
				autocompleteLocation.addListener('place_changed', () => {
					let place = autocompleteLocation.getPlace(),
						loc = place.geometry.location;					
					this.locationError = '';
					this.location = {
						latitude: loc.lat(),
						longitude: loc.lng()
					};
				});
			}
			if ($container.find('input[address-location]')[0]) {

				let autocompleteAddress = new google.maps.places.Autocomplete($container.find('input[address-location]')[0], { types: ['geocode'] });

				// When the user selects an address from the dropdown, populate the address
				// fields in the form.
				autocompleteAddress.addListener('place_changed', () => {
					let place = autocompleteAddress.getPlace();
					this.mailingAddress = _.chain(place.address_components).map(item => [item.types[0], item.long_name]).fromPairs().value();
					if (['United States', 'Canada'].indexOf(this.mailingAddress.country) === -1 && this.mailingAddress.street_number && this.mailingAddress.route) {
						this.international = place.formatted_address;
					}
				});

			}
		}, 500);

		// focus handler for GTM logging of form completion
		$container.on("focusin", e => {
			if (window.dataLayer && e.target.id) {
				window.dataLayer.push({
					event: "configurator_request_quote_form",
					data: {
						configuratorRequestQuote: {
							fieldId: e.target.id
						}
					}
				});
			}
		});
	},
	created(){
		localize().then( local => this.local = local );
	}
}

function deg2rad(deg) {
	return deg * (Math.PI / 180)
}

function fillGeo(el) {
	var deferred = $.Deferred();
	function cancel() {
		$(this).removeClass('loading-location').off('click', cancel);
	}
	if (el.parent().hasClass('loading-location')) {
		return deferred;
	}
	el.parent().addClass('loading-location').removeClass('fallback').on('click', cancel);
	navigator.geolocation.getCurrentPosition(function (position) {

		if (!el.parent().hasClass('loading-location')) {
			return;
		}
		var latlng = { lat: position.coords.latitude, lng: position.coords.longitude },
			geo = new google.maps.Geocoder();
			geo.geocode({ 'location': latlng }, function (results, status) {
			if (!el.parent().hasClass('loading-location')) {
				return;
			}
			if (status === google.maps.GeocoderStatus.OK) {
				if (results[0]) {
					el.val(results[0].formatted_address);
					deferred.resolve(latlng);
				} else {
					deferred.reject();
					console.info('No results found');
				}
			} else {

				deferred.reject();
				console.info('Geocoder failed due to: ' + status);
			}
			el.parent().removeClass('fallback').removeClass('loading-location').off('click', cancel);
		});
	}, function (PosError) {
		console.error(PosError);

		geoFallback(el).done(latlng => {
			deferred.resolve(latlng);
		}).fail(() => {
			deferred.reject();
		});

		el.parent().addClass('fallback').off('click', cancel);
	}, { enableHighAccuracy: true, maximumAge: 10000, timeout: navigator.userAgent.toLowerCase().indexOf("android") > -1 ? '15000' : '5000' });
	return deferred;
}

function filterDealers(selectedTruck, dealers) {
	function M2Filter(apiDealers) {
		const arr = [];
		apiDealers.forEach((x) => {
			if (x.isInternational) {
				arr.push(x);
			} else {
				var lowerCaseTrucks = x.slsSvcProdDescList
					.concat(x.slsOnlyProdDescList)
					.map(function (a) { return a.toLowerCase(); });
				if (lowerCaseTrucks.indexOf('m2') !== -1) {
					arr.push(x);
				}
			}
		});

		return arr;
	}

	function P4Filter(apiDealers) {
		let arr = [];
		apiDealers.forEach(function (x) {
			if (x.isInternational) {
				arr.push(x);
			} else {
				var lowerCaseTrucks = x.slsSvcProdDescList
					.concat(x.slsOnlyProdDescList)
					.map(function (a) { return a.toLowerCase(); });
				if (lowerCaseTrucks.indexOf('cascadia') !== -1) {
					arr.push(x);
				}
			}
		});
		return arr;
	}

	function NoFilter(apiDealers) {
		return apiDealers;
	}

	function GetFilter(truck) {
		return NoFilter;
		//if (truck.indexOf('cascadia') > -1 || truck.indexOf('p4') > 0) {
		//	return P4Filter;
		//} else if (truck.indexOf('m2') > -1) {
		//	return M2Filter;
		//} else {
		//	return NoFilter;
		//}
	}

	let filter = GetFilter.call(this, selectedTruck ? selectedTruck.toLowerCase() : 'p4');

	return filter(dealers);
}

function geoFallback(el) {
	var deferred = $.Deferred();
	if (el.parent().hasClass('loading-location') || el.val() === '') {
		$.ajax({
			url: 'https://api.ipstack.com/check?access_key=7652d0f71a5071a6044703dc68df0d05&output=json&legacy=1',
			dataType: 'json',
			localCache: true
		}).done(function (data) {
			el.parent().removeClass('loading-location');
			if (data.city && data.region_code) {
				el.val(data.city + ', ' + data.region_code);
				deferred.resolve({ lat: data.latitude, lng: data.longitude });
			}
			else {
				deferred.reject();
			}
		});
	}
	return deferred;
}

Vue.component('lead-submit',options);